const getLayoutVars = () => {
  return {}
}

export default getLayoutVars
